/** 与主站共用 localStorage/sessionStorage 键名：token / user / rememberMe */

export function getAuthToken() {
  return String(localStorage.getItem('token') || sessionStorage.getItem('token') || '').trim()
}

export function isLoggedIn() {
  return !!getAuthToken()
}

export function getUser() {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user')
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function getUserLabel() {
  const u = getUser()
  if (!u) return ''
  return (
    String(u.nickname || u.name || u.username || u.phone || u.email || '').trim() ||
    '已登录'
  )
}

/**
 * @param {{ token: string, user?: object, rememberMe?: boolean }} payload
 */
export function saveAuth(payload) {
  const remember = payload.rememberMe !== false
  const storage = remember ? localStorage : sessionStorage
  // 登录时清另一侧，避免串号
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('user')

  storage.setItem('token', payload.token)
  if (payload.user) {
    storage.setItem('user', JSON.stringify(payload.user))
  }
  localStorage.setItem('rememberMe', remember ? '1' : '0')
}

export function clearAuth() {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('user')
  localStorage.removeItem('opengate_user_token')
}

export function getRememberMeDefault() {
  const v = localStorage.getItem('rememberMe')
  if (v === null) return true
  return v === '1' || v === 'true'
}

/** 调试台等请求头：与主站 api 拦截器一致 */
export function getAuthorizationHeader() {
  return getAuthToken()
}
